// extracted by mini-css-extract-plugin
export default {"formRow":"ShippingAddressForm_formRow__qhepO","field":"ShippingAddressForm_field__luFgg","button":"ShippingAddressForm_button__JItZ3"};